
const team = [
  {
    photo: "/team-ben.jpg",
    photoPosition: "center top",
    name: "BEN ZHANG",
    role: "Technical",
    points: ["Ex CTO - Bite Investments", "15+ Years in Software", "$100M+ value created", "Founded & exited a fintech agency"],
  },
  {
    photo: "/team-hugh.jpg",
    photoPosition: "center 15%",
    name: "HUGH CARNEGIE",
    role: "Operations",
    points: ["Ex Head of Ops - Bite Stream", "5+ Years leading Start-up Ops", "3x Product GTM - $5M ARR", "Operational playbook specialist"],
  },
  {
    photo: "/team-cher.png",
    name: "CHER TRUMAN",
    role: "Marketing & Growth",
    note: "Joining at seed round",
    points: ["Brand & Media Strategy Lead - WPP Media", "International client acquisition", "Pinterest, Müller accounts", "MSc Leeds & Executive Branding, Oxford"],
  },
  {
    photo: "/team-george.png",
    name: "GEORGE YANG",
    role: "Strategic Advisor",
    points: ["Investor in Anthropic, Stripe, xAI, Databricks, Notion.AI", "Ex-Partner, CVC · Pantheon Asset · Shengshi Investment", "$10B AUM · $20B+ transaction experience"],
  },
];

export function TeamSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-4">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          Built to scale with AI
        </h2>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-4">
        {team.map((m) => (
          <div key={m.name} className="flex flex-col items-center text-center">
            <div className="w-[140px] h-[140px] rounded-full overflow-hidden mb-4 shrink-0">
              <img
                src={m.photo}
                alt={m.name}
                className="w-full h-full object-cover"
                style={{ objectPosition: "photoPosition" in m ? m.photoPosition : undefined }}
              />
            </div>
            <div className="text-[12px] font-bold uppercase tracking-[0.2em] mb-0.5">
              {m.name}
            </div>
            <div className="text-[11px] text-[var(--color-accent)] uppercase tracking-[0.15em] mb-2">
              {m.role}
            </div>
            <ul className="space-y-1">
              {m.points.map((p) => (
                <li key={p} className="text-[10px] text-[var(--color-fg-secondary)] leading-snug">{p}</li>
              ))}
            </ul>
            {m.note && (
              <div className="mt-2 text-[11px] text-[#4533f7] font-medium">
                {m.note}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)] font-[family-name:var(--font-mono)] text-[11px] flex gap-6">
        <span>
          <span className="text-[var(--color-accent)] font-bold mr-1">DEV</span>
          <span className="text-[var(--color-fg-secondary)]">5-person dev team + AI agents ship 24/7</span>
        </span>
        <span>
          <span className="text-[var(--color-fg)] font-bold mr-1">KEY SEED HIRE:</span>
          <span className="text-[var(--color-fg-secondary)]">Head of Corp Dev / M&A — Deal sourcing · Valuation · Integration</span>
        </span>
      </div>
    </div>
  );
}
